import { useMemo } from 'react';
import { pickBy, isArray, size, some, isString } from 'lodash';
import { useTranslation } from 'react-i18next';
import { filtersTypesToRenderWithTypeName, FilterTypes } from '../constants/initialFilters';

type StringFilterTagsTypes = {
  filterType: string;
  label: string;
  preLabel: string | null;
  showType: boolean;
  value: string;
};

const useFilterTagProcessor = (confirmedFilters: FilterTypes, listOfAllFilters: any) => {
  const { t } = useTranslation();

  // Grab all typeof String filters and filter only with values
  const availableStringFilters = pickBy(
    confirmedFilters,
    (value) => isArray(value) && size(value) > 0 && some(value, isString),
  );

  // Transform all string filters to onjects with data
  const renderStringFilters: StringFilterTagsTypes[] = useMemo(() => {
    const listOfFilters = Object.keys(availableStringFilters);
    const tagsToRender = listOfFilters.map((filterType) => {
      const selectedFilters = availableStringFilters[filterType] as string[];

      let filterTypeOptions = (listOfAllFilters as any)[filterType];

      const showPreLabel = !!filtersTypesToRenderWithTypeName.includes(filterType);

      const transformedFilters = selectedFilters.map((filterValue: string) => {
        // Create same object structure for partner dealer to use label & value
        if (Array.isArray(filterTypeOptions) && filterType === 'partnerDealers') {
          const dealerTypeOptions = Object.assign(
            {},
            ...filterTypeOptions.map((key) => ({
              [key.dealerId]: { label: key.dealerName, value: key.dealerId },
            })),
          );

          filterTypeOptions = dealerTypeOptions;
        }
        return {
          value: filterTypeOptions[filterValue]?.value,
          label: filterTypeOptions[filterValue]?.label,
          preLabel: showPreLabel ? t(`vlp.filters.filterOptions.${filterType}.tagLabel`) : null,
          showType: showPreLabel,
          filterType,
        };
      });
      return transformedFilters;
    });
    return ([] as StringFilterTagsTypes[]).concat(...tagsToRender);
  }, [availableStringFilters, listOfAllFilters, t]);

  const filterCount = renderStringFilters.length;

  return { renderStringFilters, filterCount };
};

export default useFilterTagProcessor;
